import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Cómo obtengo acceso?',
    a: 'Descarga digital inmediata tras el pago. Todo llega a tu WhatsApp y correo en minutos.'
  }, {
    q: '¿Hay cargo mensual?',
    a: 'No. Pago único de $14.997. Una sola vez, para siempre.'
  }, {
    q: '¿Por qué el precio es tan bajo?',
    a: 'Estamos en fase de lanzamiento y necesitamos casos de éxito reales de mujeres de todo el país. Cuando tengamos los testimonios que buscamos, el precio sube sin aviso.'
  }, {
    q: '¿Sirve si nunca vendí nada?',
    a: 'Sí. Está diseñado específicamente para quien empieza desde cero. El Bono #3 existe exactamente para eso.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Sí. Acceso permanente desde el momento del pago.'
  }, {
    q: '¿Funciona aunque suban los precios de los ingredientes?',
    a: 'Sí. Por eso incluimos la Calculadora Anti-Inflación. Ponés el costo actual y ella te dice cuánto cobrar para mantener tu margen.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-spice-50" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-12 text-gray-900" data-id="element-96">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-97">
          {faqs.map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-98" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-spice-200 rounded-xl overflow-hidden shadow-sm" data-id="element-99">
      <button className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-100">
        <span className="font-bold text-gray-900 text-base md:text-lg pr-4" data-id="element-101">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-spice-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-102" />
      </button>
      <div className={`px-4 md:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-103">
        <p className="text-gray-600" data-id="element-104">{answer}</p>
      </div>
    </div>;
}